module.exports = __webpack_public_path__ + "img/logo-ddwe.f6a9f670.svg";